import { useEffect, useRef, useState, type CSSProperties, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export default function ClimberMarker({ style, children, showCompetitors }: { style: CSSProperties; children: ReactNode; showCompetitors: boolean }) {
  const marker = useRef<HTMLDivElement>(null);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const [position, setPosition] = useState<{ left: number; top: number } | null>(null);
  const hide = () => { clearTimeout(timer.current); setPosition(null); };
  const show = () => {
    if (!showCompetitors) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      const rect = marker.current?.getBoundingClientRect();
      if (!rect) return;
      const width = Math.min(300, window.innerWidth - 32);
      setPosition({ left: Math.max(16, Math.min(rect.left, window.innerWidth - width - 16)), top: rect.bottom + 12 });
    }, 400);
  };
  useEffect(() => {
    const dismiss = () => setPosition(null);
    window.addEventListener('scroll', dismiss, true);
    window.addEventListener('resize', dismiss);
    return () => {
      clearTimeout(timer.current);
      window.removeEventListener('scroll', dismiss, true);
      window.removeEventListener('resize', dismiss);
    };
  }, []);
  return <>
    <div ref={marker} className="cf-you" style={style} tabIndex={0} aria-label="Your position on the daily climb" aria-describedby={showCompetitors && position ? 'cf-your-competitors-tip' : undefined} onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide} onKeyDown={event => { if (event.key === 'Escape') hide(); }}>{children}</div>
    {showCompetitors && position && createPortal(<div id="cf-your-competitors-tip" className={`cf-climber-tooltip${marker.current?.closest('.cf-dark') ? ' cf-climber-tooltip-dark' : ''}`} role="tooltip" style={position}><strong>Daily competitors</strong><p>Writers who share their progress appear beside your trail after they start writing. Plus lets you see their names, word counts and who is ahead or behind. Their writing stays private.</p></div>, document.body)}
  </>;
}
